import JSONCrush from "jsoncrush";

const parsePreviewURL = (urlData) => {
  const previewUrl = urlData?.customAttributes?.find((e) => e.key === "_previewURL")?.value;
  const params = previewUrl?.split("?")[1].split("&");
  let patches = [];
  let points = [];

  if (params) {
    for (let i = 0; i < params.length; i++) {
      const keyValue = params[i].split("=");

      if (keyValue[0] === "points") {
        try {
          points = JSON.parse(JSONCrush.uncrush(decodeURIComponent(keyValue[1])));
        } catch (e) {
          console.log(e);
        }
      } else if (keyValue[0] === "data") {
        try {
          patches = JSON.parse(JSONCrush.uncrush(decodeURIComponent(keyValue[1])));
        } catch (e) {
          console.log(e);
        }
      }
    }
  }

  return {
    patches,
    previewUrl,
    points,
  };
};

export default parsePreviewURL;
